import type { TranscriptionRuntime } from '@shared/store/impl/audioSettings'
import type { SystemAudioCaptureStatus } from '@shared/types/AudioCapturePermissions'

/**
 * Electron's CATAP loopback cannot run when the System Audio Recording gate is
 * `unavailable` (macOS < 14.2) or `error` (TCC SPI unreadable). Neither is
 * grantable, so the recording falls back to Recall. `denied` / `notDetermined`
 * stay on electron: the user can still grant those.
 *
 * Single source of the fallback policy, shared by the main-process runtime
 * selection and the renderer permission surfaces so they cannot drift. Only
 * type imports on purpose, so main, renderer, and tests can all load it.
 */
export function resolveRuntimeForSystemAudioStatus(
  runtime: TranscriptionRuntime,
  systemAudioStatus: SystemAudioCaptureStatus | undefined,
): TranscriptionRuntime {
  if (runtime !== 'electron') {
    return runtime
  }
  return systemAudioStatus === 'unavailable' || systemAudioStatus === 'error' ? 'recall' : runtime
}
